import axios from 'shared/lib/axios'
import config, { exploreLocations, Locations } from 'configuration'
import { redirect } from 'shared/lib/helpers'

// TODO: move this actionTypes to own file
export const LOGOUT = 'LOGOUT'
export const LOGOUT_SUCCESS = 'LOGOUT'
export const FETCH_USERS_DETAILS = 'FETCH_USERS_DETAILS'

export function logout(role) {
  return (dispatch) =>
    axios
      .get('/api/auth/logout')
      .then(() => dispatch({ type: LOGOUT_SUCCESS }))
      .then(() =>
        role === 'customer'
          ? redirect(config.explore, exploreLocations.LOGIN)
          : redirect(config.website, `${Locations.LOGIN}/${role}`)
      )
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn(err)
      })
}

export const fetchUsersDetails = (dispatch) => {
  return axios.get('/api/auth/user').then((response) => {
    dispatch({ type: FETCH_USERS_DETAILS, payload: response.data })
  })
}
